import { Component, input, output } from '@angular/core';
import { ITransactions } from '../../store/summaryOfChanges/state';

@Component({
    selector: 'app-user-transactions',
    templateUrl: './user-transactions.component.html',
    styleUrls: ['./user-transactions.component.scss'],
    standalone: false
})
export class UserTransactionsComponent {
  transactions = input<ITransactions[]>([]);
  selectedTransaction = output<ITransactions>();
}
